import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {debounce} from "lodash";
import {
    SetUserAction,
    UpdateMeAction,
    LoadMeAction,
    actions,
    toastActions,
    countriesConstants,
    statesConstants,
    DistrictDropdown,
    ErrorMessageAction,
    SuccessMessageAction,
    LoadCurriculaAction,
    filterConstants,
    CreateSchoolAction, StateField, WarningMessageAction
} from "mindsets-js-sdk";
import useAuth from "../../hooks/useAuth";
import CurriculumSelector from "common/CurriculumSelector";

import './profile_school_add.scss';

export default function () {
    useAuth(['teacher']);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const me = useSelector(state => state.me);
    const user = useSelector(state => state.user);
    const curricula = useSelector(state => state.curricula);
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [districtId, setDistrictId] = useState(null);
    const [name, setName] = useState('');
    const [location, setLocation] = useState('');
    const [city, setCity] = useState('');
    const [zip, setZip] = useState('');
    const [phone, setPhone] = useState('');
    const [curriculum_id, setCurriculumId] = useState(null);

    useEffect(() => {
        dispatch(LoadCurriculaAction({
            'filters[is_enabled][0]': filterConstants.EXPRESSION_TRUE,
            limit: 0
        }));
    }, []);
    useEffect(() => {
        if (!!me) {
            if (!user) {
                dispatch(SetUserAction(me));
                if (me.school) {
                    let country = '';
                    let state = '';
                    if (me.school.district) {
                        if (me.school.district.country) {
                            country = me.school.district.country;
                        }
                        if (me.school.district.state) {
                            state = me.school.district.state;
                        }
                    }
                    if (!country && me.school.country) {
                        country = me.school.country;
                    }
                    if (!state && me.school.state) {
                        state = me.school.state;
                    }
                    setCountry(country);
                    setState(state);
                }
            } else {
                if (user.school) {
                    let country = '';
                    let state = '';
                    if (user.school.district) {
                        if (user.school.district.country) {
                            country = user.school.district.country;
                        }
                        if (user.school.district.state) {
                            state = user.school.district.state;
                        }
                    }
                    if (!country && user.school.country) {
                        country = user.school.country;
                    }
                    if (!state && user.school.state) {
                        state = user.school.state;
                    }
                    setCountry(country);
                    setState(state);
                }
            }
        }
    }, [me]);
    useEffect(() => {
        if (country) {
            const curricula_filtered = curricula.filter(c => c.country_code === country && (c.state_code === state || !state));
            const curricula_filtered_default = curricula_filtered.filter(c => c.is_default);
            if (curricula_filtered_default.length > 0) {
                setCurriculumId(curricula_filtered_default[0].id);
            } else if (curricula_filtered.length > 0) {
                setCurriculumId(curricula_filtered[0].id);
            } else {
                setCurriculumId(null);
            }
        }
    }, [country, state]);

    const debounced = useCallback(debounce(a => a(), 600), []);

    function validate(report = false) {
        if (!name) {
            if (report === true) {
                dispatch(ErrorMessageAction('Please provide your school name'));
            }

            return false;
        }
        if (!country) {
            if (report === true) {
                dispatch(ErrorMessageAction('Please choose a country'));
            }

            return false;
        }
        if (Object.keys(statesConstants.STATES).includes(country) && !state) {
            if (report === true) {
                dispatch(ErrorMessageAction('Please choose a state'));
            }

            return false;
        }
        if (!location) {
            if (report === true) {
                dispatch(ErrorMessageAction('Please provide your school\'s street address'));
            }

            return false;
        }
        if (!city) {
            if (report === true) {
                dispatch(ErrorMessageAction('Please provide your school\'s city name'));
            }

            return false;
        }
        if (!zip) {
            if (report === true) {
                dispatch(ErrorMessageAction('Please provide your school\'s zip code'));
            }

            return false;
        }
        if (!phone) {
            if (report === true) {
                dispatch(ErrorMessageAction('Please provide your school\'s contact phone number'));
            }

            return false;
        }

        return true;
    }

    function onSave() {
        if (validate(true)) {
            dispatch(CreateSchoolAction({
                name,
                country,
                state,
                city,
                location,
                zip,
                phone,
                curriculum_id,
                district_id: districtId
            }))
                .then(school => dispatch(UpdateMeAction({school_id: school.id})))
                .then(() => dispatch(LoadMeAction()))
                .then(() => dispatch(SuccessMessageAction('Your school had been successfully added to our database and assigned to your profile.')))
                .then(() => navigate('/profile'))
                .catch(error => {
                    console.error(error);
                    dispatch(actions.LoadingAction(false));
                    dispatch(toastActions.ErrorMessageAction('We could not successfully save your data. Please try again.'));
                });
        }
    }

    function renderCancel() {
        return (
            <button onClick={event => {
                event.preventDefault();
                navigate('/profile');
            }} className="btn btn-flat">Cancel
            </button>
        );
    }

    function renderAddButton() {
        return (
            <button
                onClick={event => {
                    event.preventDefault();
                    onSave();
                }}
                className={"btn " + (validate() ? "btn-dark" : "btn-grey")}>Add
                School
            </button>
        );
    }

    function renderDistrictField() {
        if (country && countriesConstants.COUNTRIES_WITH_DISTRICTS.includes(country)) {
            if (state || !Object.keys(statesConstants.STATES).includes(country)) {
                return (
                    <div className="col s12 m4">
                        <DistrictDropdown
                            onSelect={district => {
                                if (district) {
                                    setDistrictId(district.id);
                                    if (district.city) {
                                        setCity(district.city);
                                    }
                                    if (district.country) {
                                        setCountry(district.country);
                                    }
                                    if (district.state) {
                                        setState(district.state);
                                    }

                                    return district.name;
                                } else {
                                    return '';
                                }
                            }}
                            id='profile-school-district'
                            label={'School District(optional)'}
                            country={country}
                            state={state ? state : null}
                            debounce={debounced}
                            with_reset={true}
                            onReset={() => setDistrictId(null)}
                        />
                    </div>
                );
            }
        }

        return null;
    }

    function renderCountryField() {
        if (!!country && !!districtId) {
            return (
                <div className='like-selector disabled' onClick={() => {
                    dispatch(WarningMessageAction('This attribute can not be changed because School District is selected. Reset School District first.'));
                }}>{countriesConstants.COUNTRIES[country]}</div>
            );
        } else {
            return (
                <select
                    value={country}
                    onChange={event => {
                        setCountry(event.target.value);
                        setState('');
                        setCity('');
                        setDistrictId(null);
                    }}
                >
                    <option value='' disabled={true}>Please select a country*</option>
                    {Object.keys(countriesConstants.COUNTRIES).map(code => {
                        return (
                            <option key={code} value={code}>{countriesConstants.COUNTRIES[code]}</option>
                        );
                    })}
                </select>
            );
        }
    }

    function renderStateField() {
        if (!!country && !!state && !!districtId && Object.keys(statesConstants.STATES).includes(country) && Object.keys(statesConstants.STATES[country]).includes(state)) {
            return (
                <div className="col s12 m4">
                    <label>State *</label>
                    <div className='like-selector disabled' onClick={() => {
                        dispatch(WarningMessageAction('This attribute can not be changed because School District is selected. Reset School District first.'));
                    }}>{statesConstants.STATES[country][state]}</div>
                </div>
            );
        } else {
            return (
                <StateField
                    onChange={state => {
                        setState(state);
                        setDistrictId(null);
                        setCity('');
                    }}
                    country={country}
                    value={state}
                    is_mandatory={true}
                    outer_class_name='col s12 m4'/>
            );
        }
    }

    function renderCityField() {
        if (!!city && !!districtId) {
            return (
                <div className='like-selector disabled' onClick={() => {
                    dispatch(WarningMessageAction('This attribute can not be changed because School District is selected. Reset School District first.'));
                }}>{city}</div>
            );
        } else {
            return (
                <input
                    type='text'
                    value={city}
                    onChange={event => setCity(event.target.value)}
                />
            );
        }
    }

    if (!user) {
        return null;
    }

    return (
        <div className="container" id='profile-school-add'>
            <h2 className="header-new">Add Your School</h2>

            <div className="profile-school-info section">
                <div className="row">
                    <div className="col s12 m4">
                        <label>Country *</label>
                        {renderCountryField()}
                    </div>
                    {renderStateField()}
                    {renderDistrictField()}
                    <div className="col s12 m4">
                        <label>Address *</label>
                        <input
                            type='text'
                            value={location}
                            onChange={event => setLocation(event.target.value)}
                        />
                    </div>
                    <div className="col s12 m4">
                        <label>City *</label>
                        {renderCityField()}
                    </div>
                    <div className="col s12 m4">
                        <label>Zip *</label>
                        <input
                            type='text'
                            value={zip}
                            onChange={event => setZip(event.target.value)}
                        />
                    </div>
                    <div className="col s12 m4">
                        <label>School phone number *</label>
                        <input
                            type='text'
                            value={phone}
                            onChange={event => setPhone(event.target.value)}
                        />
                    </div>
                    <div className="col s12 m4">
                        <CurriculumSelector
                            curriculum_id={curriculum_id}
                            onCurriculumIdChange={setCurriculumId}
                            validation_error_messages={{}}
                            curriculums={curricula}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col s12">
                        <label>Your School's full name</label>
                        <input
                            type='text'
                            value={name}
                            onChange={event => setName(event.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="flex-row flex-v-center h100 flex-h-end flex-gap-10">
                {renderCancel()}
                {renderAddButton()}
            </div>
        </div>
    );
};
